import IntegrationModel from '@/models/integration';

export default class LicenseModel {
  id?: number;

  code!: string;

  name!: string;

  apiKey!: string;

  active!: boolean;

  integrations!: IntegrationModel[];

  channelId!: string;

  accountId!: string;

  dailyLimit!: number;

  useQueue!: boolean;

  useGeochat!: boolean;
}
